module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/296f9151c7e3d6d6c585651fe6e2bf58.png";